var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 2.33366C16.3333 1.68933 15.811 1.16699 15.1667 1.16699H7C5.067 1.16699 3.5 2.734 3.5 4.66699V23.3337C3.5 25.2667 5.067 26.8337 7 26.8337H21C22.933 26.8337 24.5 25.2667 24.5 23.3337V10.5003C24.5 9.85599 23.9777 9.33366 23.3333 9.33366H19.8333C17.9003 9.33366 16.3333 7.76666 16.3333 5.83366V2.33366ZM14.283 10.8627C13.5466 10.6786 12.8333 11.2356 12.8333 11.9946V17.5003C11.5447 17.5003 10.5 18.545 10.5 19.8337C10.5 21.1223 11.5447 22.167 12.8333 22.167C14.122 22.167 15.1667 21.1223 15.1667 19.8337V14.5836L16.0504 14.8046C16.7867 14.9887 17.5 14.4317 17.5 13.6727V12.5779C17.5 12.0425 17.1357 11.5759 16.6163 11.4461L14.283 10.8627Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8071 1.37366C19.2129 1.12449 18.6667 1.6889 18.6667 2.33323V5.83323C18.6667 6.47756 19.1891 6.9999 19.8334 6.9999H23.3334C23.9777 6.9999 24.5422 6.45377 24.293 5.85957C24.1851 5.60231 24.0301 5.36325 23.8167 5.14981L20.5168 1.84998C20.3034 1.63654 20.0643 1.48154 19.8071 1.37366Z",
    fill: "#98A2B3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.03f0ba7013a4a3117328e2c5276b463c.svg";
export { ForwardRef as ReactComponent };